import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import SwitchInput from "../shared/Inputs/SwitchInput";

import useCustomer from "../../data/useCustomer";
import LoadingWheel from "../shared/LoadingWheel";
import ConfirmModal from "../shared/Confirm/ConfirmModal";

export default function CustomerSellAVehicleToggle() {
  const [modalOpen, setModalOpen] = useState(false);

  const { customer, update } = useCustomer();

  const { register, watch, setValue, handleSubmit } = useForm();

  const onSubmit = async (data: any) => {
    console.log("Form submitted with data:", data);
    await update.mutateAsync({
      sellAVehicleQuotesEnabled: !data.sellAVehicleQuotesEnabled,
    });
  }

  useEffect(() => {
    if (customer.isLoading) return;
    if (!customer.data?.data) return;

    console.log("Customer data:", customer.data.data);

    setValue("sellAVehicleQuotesEnabled", customer.data.data.sellAVehicleQuotesEnabled ?? false);
  }, [customer.data, customer.isLoading]);

  if (customer.isLoading) {
    return <LoadingWheel />;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
      <ConfirmModal 
        open={modalOpen}
        setOpen={setModalOpen}
        title="Confirm Update"
        message={
          customer?.data?.data?.sellAVehicleQuotesEnabled 
          ? "Are you sure you want to disable SellAVehicle quotes?" 
          : "Are you sure you want to enable SellAVehicle quotes? Each lead will cost £30.00"
        }
        confirmButtonText={customer?.data?.data?.sellAVehicleQuotesEnabled ? "Disable" : "Enable"}
        onConfirm={async () => {
          setModalOpen(false);
          await onSubmit(watch());
        }}
        isLoading={update.isLoading}
      />
      <div className="flex items-center justify-between cursor-pointer" onClick={(e) => { e.preventDefault(); setModalOpen(true) }}>
        <SwitchInput
          label="SellAVehicle"
          register={register}
          registerName={"sellAVehicleQuotesEnabled"}
          watch={watch}
          setValue={setValue} 
          classes="pointer-events-none"
        />
      </div>
    </form>
  );
}